import React, { Component } from 'react';
import Select from 'react-select';
import { Grid, Row, Col, Panel, Button, Tabs, Tab, ButtonToolbar, Breadcrumb, Input } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { Toolbar, Data } from 'react-data-grid-addons';
import ReactDataGrid from 'react-data-grid';

const { Selectors } = Data;

export class WeightChangeModalMulti extends Component {
    constructor() {
        super();
        this.state = {
            rows: [],
            selectedRows: null,
            editedRows: [],
            filters: {},

            sumShippingWeight: 0,
        }
    }

    componentDidMount() {
        this.props.fetchShippingWeightTracking(this.props.salesOrderId).then((response) => {
            if (response.data) {
                this.initializeModal(response.data.weights);
            }
        }, (err) => {
            if (err.status === 500 || err.status === 404) {
                alert("Server error, please refresh page. If problem persists, contact administrator.");
            }
        });
    }

    componentWillReceiveProps(nextProps) {
    }

    initializeModal = (array) => {
        let index = 0;
        let formatter = [];
        let sum = 0;
        if (array && array.length > 0) {
            array.map(r => {
                formatter.push({ Idx: index++, Package_Weight: r.weight, Package_Note: r.note, Tracking_Number: r.tracking });
                sum += Number(r.weight);
            })
        } else {
            formatter.push({ Idx: 0, Package_Weight: "", Package_Note: "", Tracking_Number: "" });
        }
        this.setState({
            rows: formatter,
            sumShippingWeight: sum,
            selectedRows: [],
            editedRows: [],
        });
    }

    handleOnSave = (e) => {
        e.preventDefault();
        this.state.rows.map((r) => {
            r.recreate = false;
        });
        this.props.onSave(this.state.rows);
    }

    handleOnSavePrint = (e) => {
        e.preventDefault();
        this.state.rows.map((r) => {
            r.recreate = false;
        });
        this.props.onSavePrint(this.state.rows);
    }

    handleOnRecreate = (e) => {
        e.preventDefault();
        let { selectedRows } = this.state;
        selectedRows.map((r) => {
            r.recreate = true;
        })
        this.props.onSavePrint(selectedRows);
    }

    clickNew(e) {
        e.preventDefault();
        let rows = Selectors.getRows(this.state);
        let index = rows.length;
        let newRow = { Package_Weight: null, Package_Note: null, Tracking_Number: null, Idx: index };
        rows.push(newRow);
        let editedRows = [...this.state.editedRows];
        editedRows.push(newRow)
        this.setState({ rows, editedRows })
    }

    deleteCategory(e) {
        e.preventDefault();
        let rows = [...this.state.rows];
        let editedRows = [...this.state.editedRows];
        let index = _.findIndex(rows, { Idx: this.state.selectedRows[0].Idx })
        rows.splice(index, 1);
        index = _.findIndex(editedRows, { Idx: this.state.selectedRows[0].Idx })
        editedRows.splice(index, 1);
        this.setState({ rows, editedRows, selectedRows: [] })
    }

    renderWeightChangeTable() {
        const getRows = () => {
            return Selectors.getRows(this.state);
        }
        const getSize = () => {
            return getRows().length;
        }
        const rowGetter = rowIdx => {
            var rows = getRows();
            return rows[rowIdx];
        }
        const handleRowUpdated = e => {
            this.setState({ sortColumn: null, sortDirection: null })
            let rows = getRows();
            let sumShippingWeight = 0;
            let editedRows = this.state.editedRows.slice(0);
            Object.assign(rows[e.rowIdx], e.updated);
            editedRows.forEach((element, index) => {
                if (element.Idx === rows[e.rowIdx].Idx)
                    editedRows.splice(index, 1)
            }, this);
            editedRows.push(rows[e.rowIdx]);
            rows.map(r => {
                if (isFinite(r.Package_Weight)) {
                    sumShippingWeight += Number(r.Package_Weight);
                }
            });
            this.setState({
                rows: rows,
                editedRows: editedRows,
                sumShippingWeight: sumShippingWeight,
            });
        }
        // const onRowsSelected = (rows) => {
        //     let newRows = getRows();
        //     newRows.map(r => {
        //         r.isSelected = false;
        //     })
        //     rows.map(r => {
        //         newRows[r.rowIdx].isSelected = true;
        //     });
        //     this.setState({ rows: newRows, selectedRows: [rows[0].row] });
        // }
        const onRowsSelected = (rows) => {
            let newRows = getRows();
            let selectedRows = [...this.state.selectedRows];
            rows.map(r => {
                newRows[r.rowIdx].isSelected = true;
                selectedRows.push(r.row);
            });
            this.setState({ rows: newRows, selectedRows });
        }
        // const onRowsDeselected = (rows) => {
        //     let newRows = getRows();
        //     rows.map(r => {
        //         newRows[r.rowIdx].isSelected = false;
        //     });
        //     this.setState({ rows: newRows, selectedRows: [] });
        // }
        const onRowsDeselected = (rows) => {
            let newRows = [...this.state.rows];
            let selectedRows = [...this.state.selectedRows];
            rows.map((r) => {
                newRows[r.rowIdx].isSelected = false;
                const rowIndex = selectedRows.indexOf(r.row);
                selectedRows.splice(rowIndex, 1);
            });
            this.setState({ rows: newRows, selectedRows });
        }

        const columns = [
            {
                key: 'Package_Weight',
                name: <Translate value="weight_lbs" />,
                resizable: true,
                sortable: true,
                filterable: true,
                editable: true,
                width: 100,
            },
            {
                key: 'Package_Note',
                name: <Translate value="note" />,
                resizable: true,
                sortable: true,
                filterable: true,
                editable: true,
                width: 250,
            },
            {
                key: 'Tracking_Number',
                name: <Translate value="tracking_num" />,
                resizable: true,
                sortable: true,
                filterable: true,
                width: 150,
            },
        ]

        return (
            <Row>
                <Col>
                    <div style={{ maxWidth: '550px', marginLeft: '25px' }}>
                        <ReactDataGrid
                            // rowKey="Idx"
                            enableCellSelect={true}
                            columns={columns}
                            rowGetter={rowGetter}
                            rowsCount={getSize()}
                            minHeight={150}
                            rowHeight={25}
                            headerRowHeight={45}
                            enableRowSelect='single'
                            onRowUpdated={handleRowUpdated}
                            rowSelection={{
                                showCheckbox: true,
                                onRowsSelected,
                                onRowsDeselected,
                                selectBy: {
                                    isSelectedKey: 'isSelected'
                                }
                            }}
                        />
                    </div>
                </Col>
            </Row>
        )
    }

    render() {
        const {
            finalShippingWeight,
        } = this.props;

        const {
            sumShippingWeight,
        } = this.state;

        return (
            <div>
                <ButtonToolbar style={{ marginLeft: '5px', marginBottom: '7px' }}>
                    <Button
                        bsStyle="primary"
                        onClick={(event) => { this.clickNew(event) }}
                    >
                        <em className="fa fa-plus marginRightStyle" /><Translate value="package" />
                    </Button>
                    <Button
                        style={{ marginRight: '5px' }}
                        bsStyle="danger"
                        onClick={(event) => { this.deleteCategory(event) }}
                        disabled={!this.state.selectedRows || this.state.selectedRows.length != 1}
                    ><em className="fa fa-trash marginRightStyle" /><Translate value="delete" />
                    </Button>
                    {/* <Input type="text" style={{ width: '100px' }} value={sumShippingWeight + ' lbs'} disabled={true} /> */}
                </ButtonToolbar>
                <Row>
                    <Col className="text-center">
                        <span>
                            {this.renderWeightChangeTable()}
                        </span>
                    </Col>
                </Row>
                <Row style={{ marginLeft: '5px', marginTop: '5px' }}>
                    <Col sm={4}>
                        <label><Translate value="total_shipping_weight_lbs" />:</label>
                    </Col>
                </Row>
                <Row style={{ marginLeft: '5px' }}>
                    <Col sm={4}>
                        <Input
                            type="number"
                            // value={finalShippingWeight}
                            value={sumShippingWeight}
                            onChange={this.props.onChange}
                            disabled={true}
                        />
                    </Col>
                </Row>
                <Row className="centerStyle" style={{ marginTop: '0px' }}>
                    <Button
                        style={{ marginRight: '5px' }}
                        bsStyle="primary"
                        onClick={(e) => { this.handleOnSave(e); }}
                    >
                        <Translate value="save" />
                    </Button>
                    <Button
                        style={{ marginRight: '5px' }}
                        bsStyle="success"
                        onClick={(e) => { this.handleOnSavePrint(e); }}
                    >
                        <Translate value="save_and_print" />
                    </Button>
                    <Button
                        bsStyle="success"
                        onClick={(e) => { this.handleOnRecreate(e); }}
                        disabled={!this.state.selectedRows || this.state.selectedRows.length < 1}
                    >
                        <Translate value="recreate" />
                    </Button>
                </Row>
            </div>
        );
    }
}

export default WeightChangeModalMulti;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/weightChangeModalMulti.jsx